export default {
  SET_ASSETS_DATA(state, data) {
    state.assets = data;
  },
};
